export default interface PaymentMethod {
  id: PaymentMethodKey;
  name: string;
  key: string;
  created_at: string;
  updated_at: string;
  show: boolean;
}

export enum PaymentMethodKey {
  CreditCard = 1,
  Boleto = 2,
  OnlineDebit = 3,
  DebitCard = 4,
  Pix = 5,
  Free = 6,
  ZeroValue = 7,
  Cash = 8,
}
